import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IUiSlice {
  logoVisible: boolean,
  expandedProducts: Record<string, boolean>
}

interface SetProductExpandedPayload {
  id: string;
  expanded: boolean;
}

export const UiSlice = createSlice({
  name: "ui",
  initialState: {
    logoVisible: true,
    expandedProducts: {}
  } as IUiSlice,
  reducers: {
    setLogoVisible: (state, action: PayloadAction<boolean>) => {
      state.logoVisible = action.payload;
    },
    setProductExpanded: (state, action: PayloadAction<SetProductExpandedPayload>) => {
      const { id, expanded } = action.payload;
      state.expandedProducts[id] = expanded;
    }
  }
});

export const { setLogoVisible, setProductExpanded } = UiSlice.actions;

export default UiSlice.reducer;